// extracted by mini-css-extract-plugin
module.exports = {"roundedSearch":"style_roundedSearch__1DcEt","roundedSearchReport":"style_roundedSearchReport__23ZXL"};